import { render, staticRenderFns } from "./monthCard-storedValue.vue?vue&type=template&id=6841b304&scoped=true&"
import script from "./monthCard-storedValue.vue?vue&type=script&lang=js&"
export * from "./monthCard-storedValue.vue?vue&type=script&lang=js&"
import style0 from "./monthCard-storedValue.vue?vue&type=style&index=0&id=6841b304&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6841b304",
  null
  
)

export default component.exports